import { Injectable } from '@angular/core';
import { LoadOptions } from 'devextreme/data';
import { StockMoveDocumentsService } from '../../stock-move-documents/stock-move-documents/stock-move-documents.service';
import { StockMoveIncoming } from './stock-move-incoming.model';
import { StockMoveIncomingHeaderStatus } from '../stock-move-incoming-header-statuses/stock-move-incoming-header-status.model';

@Injectable({
  providedIn: 'root'
})
export class StockMoveIncomingsService extends StockMoveDocumentsService<StockMoveIncoming, StockMoveIncomingHeaderStatus> {
  public override url: string = 'StockMoveIncomingHeader';
  
  public override defaultOptions: LoadOptions = {
    expand: [
     'CurrentStatusLink.StatusId',
      'ResponsibleUserId',
      'Lines($orderby=LineNo;$expand=UnitId,Children,ParentId,ToStockLocationId)',
      'Statuses.StatusId',
      'DocumentDataCollection.ThirdId.ThirdContacts',
      'DocumentDataCollection.ThirdId.Addresses',
      'DocumentDataCollection.ContactId',
      'DocumentDataCollection.AddressId',
      'DocumentDataCollection.DeliveryAddressId',
      'ThirdId.ContactInformations.ThirdId',
      'ThirdId.ContactInformations.ContactTypeId',
      'DocumentRelations'
    ]
  };

  public override async getInstance(incoming?: Partial<StockMoveIncoming>): Promise<any> {

    let element = {
      Date: new Date(),
      ...incoming,
    };
    element = await this.refreshResponsibleUser(element);
    // element = await this.refreshThirdDeliveryTimeFromSupplier(element);
    return element;
  }
}

export enum StockMoveIncomingContextMenuItemActionCode {
  PrintToZIP = 'PrintToZIP',
  PrintToPDF = 'PrintToPDF',
  Status = 'Status'
}